import { CompetitorFamily, CompetitorMember } from "./external"

export function competitorFamilyUrl(family: Pick<CompetitorFamily, 'internalReference'>) {
    return `/external/portfolio/family/${encodeURIComponent(family.internalReference)}`
}

export function competitorMemberUrl(member: Pick<CompetitorMember, 'internalReference'>) {
    return `/external/portfolio/member/${encodeURIComponent(member.internalReference)}`
}

/**
 * Country chip label. When a country repeats within a family the bare code is ambiguous, so we
 * append the member reference — e.g. `WO (P001 WO1)` — mirroring the Patents portfolio rule.
 */
export function competitorCountryLabel(
    member: Pick<CompetitorMember, 'countryCode' | 'internalReference'>,
    isOnly = true,
): string {
    return isOnly ? member.countryCode : `${member.countryCode} (${member.internalReference})`
}
